const AUTHORIZATION_TOKEN = "access";
const REFRESH_TOKEN = "refresh";


export const saveJsonData = (key, jsonData) => {
  try {
    const serializedState = JSON.stringify(jsonData);
    sessionStorage.setItem(key, serializedState);
  } catch (err) { 
    console.log(err);
  }
}

export const saveData = (key, data) => { 
  try {
    sessionStorage.setItem(key, data);
  } catch (err) { 
    console.log(err);
  }
}

export const loadData = (key) => { 
  try { 
    return sessionStorage.getItem(key);
  } catch (err) {
    console.log(err);
  }
}

export const clearData = () => {
  try {
    sessionStorage.clear();
  } catch (err) {
    console.log(err);
  }
}

export const saveToken = (accessToken, refreshToken, idToken) => {
  try {
    sessionStorage.setItem(AUTHORIZATION_TOKEN, accessToken);
    sessionStorage.setItem(REFRESH_TOKEN, refreshToken);
  } catch (err) {
    console.log(err);
  }
};

export const retrieveRefreshToken = () => {
  let token = sessionStorage.getItem(REFRESH_TOKEN);
  return !token || token == null || token === "" ? "sdjnsc" : token;
};

export const retrieveToken = () => {
  let token = sessionStorage.getItem(AUTHORIZATION_TOKEN);
  return !token || token == null || token === "" ? "sdjnsc" : token;
};
